import type { WidgetTelemetryFilters } from '../../../../api/widgetTelemetry';

interface FiltersBarProps {
  value: WidgetTelemetryFilters;
  onChange: (next: WidgetTelemetryFilters) => void;
}

const DEVICE_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All devices' },
  { value: 'desktop', label: 'Desktop' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'tablet', label: 'Tablet' },
];

/**
 * Lightweight filter bar for widget telemetry views. All three inputs map
 * 1:1 to a registered GA4 custom dimension on property 530668124.
 */
export default function FiltersBar({ value, onChange }: FiltersBarProps) {
  const setField = (field: keyof WidgetTelemetryFilters, raw: string) => {
    const next: WidgetTelemetryFilters = { ...value };
    if (!raw) {
      delete next[field];
    } else if (field === 'deviceCategory') {
      if (raw === 'mobile' || raw === 'desktop' || raw === 'tablet') {
        next.deviceCategory = raw;
      }
    } else if (field === 'ipRegionCode') {
      next.ipRegionCode = raw.toUpperCase().slice(0, 2);
    } else {
      next.utmSource = raw;
    }
    onChange(next);
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <input
        type="text"
        placeholder="State (e.g. NY)"
        value={value.ipRegionCode ?? ''}
        onChange={(e) => setField('ipRegionCode', e.target.value)}
        maxLength={2}
        className="w-24 px-2 py-1 text-xs border border-stone-300 dark:border-stone-600 rounded-md bg-white dark:bg-[#1a1f1c] text-bark-900 dark:text-stone-200 uppercase"
      />
      <input
        type="text"
        placeholder="utm_source"
        value={value.utmSource ?? ''}
        onChange={(e) => setField('utmSource', e.target.value)}
        className="w-32 px-2 py-1 text-xs border border-stone-300 dark:border-stone-600 rounded-md bg-white dark:bg-[#1a1f1c] text-bark-900 dark:text-stone-200"
      />
      <select
        value={value.deviceCategory ?? ''}
        onChange={(e) => setField('deviceCategory', e.target.value)}
        className="px-2 py-1 text-xs border border-stone-300 dark:border-stone-600 rounded-md bg-white dark:bg-[#1a1f1c] text-bark-900 dark:text-stone-200"
      >
        {DEVICE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
